// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8549":"0488199b7249cf43","9350":"fb52ab1de19fc8c7"}[chunkId] + ".css";
};